/**
 * Updates the recently viewed products in localStorage.
 */
export class RecentlyViewed {
  /** @static @constant {string} The key used to store the viewed products in session storage */
  static #STORAGE_KEY = 'viewedProducts';
  /** @static @constant {number} The maximum number of products to store */
  static #MAX_PRODUCTS = 4;

  /**
   * Adds a product to the recently viewed products list.
   * @param {string} productId - The ID of the product to add.
   * @param {string} [productHandle] - The handle of the product, used to render it later.
   */
  static addProduct(productId, productHandle) {
    let viewedProducts = this.getProducts();

    viewedProducts = viewedProducts.filter((entry) => entry.id !== productId);
    viewedProducts.unshift({ id: productId, handle: productHandle || null });
    viewedProducts = viewedProducts.slice(0, this.#MAX_PRODUCTS);

    localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(viewedProducts));
  }

  static clearProducts() {
    localStorage.removeItem(this.#STORAGE_KEY);
  }

  /**
   * Retrieves the list of recently viewed products from session storage.
   * @returns {{id: string, handle: string|null}[]} The list of viewed products.
   */
  static getProducts() {
    try {
      const stored = JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]');
      // Normalize legacy entries (plain ID strings written before handles were tracked).
      return stored
        .map((entry) => (typeof entry === 'string' ? { id: entry, handle: null } : entry))
        .filter((entry) => entry && entry.id);
    } catch {
      return [];
    }
  }
}
